import axios from "axios";

// Base URL: respect env override, otherwise use the CRA proxy.
const baseURL = process.env.REACT_APP_BACKEND_URL || "/api";
const api = axios.create({ baseURL });

// Attach the auth token (stored after login) to every request.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ccmc_token");
  if (token) config.headers.Authorization = `Token ${token}`;
  return config;
});

// On 401, drop the stale token and bounce to login.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem("ccmc_token");
      localStorage.removeItem("ccmc_user");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
